interface SentryTraceContext {
    status?: string;
}

interface SentryTraceEvent {
    level?: string;
    exception?: {
        values?: unknown[];
    };
    contexts?: {
        trace?: SentryTraceContext;
    };
}

function setTraceStatusIfMissing<T extends SentryTraceEvent>(event: T, status: string): T
{
    const trace = event.contexts?.trace;

    if (trace && !trace.status) {
        trace.status = status;
    }

    return event;
}

export function finalizeSentryTransactionStatus<T extends SentryTraceEvent>(event: T): T
{
    return setTraceStatusIfMissing(event, 'ok');
}

export function finalizeSentryErrorStatus<T extends SentryTraceEvent>(event: T): T
{
    const hasException = Boolean(event.exception?.values?.length);
    const isErrorLevel = event.level === 'error' || event.level === 'fatal';

    return hasException || isErrorLevel
        ? setTraceStatusIfMissing(event, 'internal_error')
        : event;
}
